import { Modal } from "antd";
import { find, get } from "lodash";
import { useMemo, useState } from "react";
import { MdDescription, MdSend } from "react-icons/md";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import Input from "shared/components/Input";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import EmailPreview from "./EmailPreview";

const View = ({
  translation: T,
  generalCost,
  project,
  onSubmit,
  initialValues,
  setInitialValues,
  loading,
}) => {
  const [open, setOpen] = useState(false);
  const upSells = get(
    project,
    `fields.upsells.${get(generalCost, "insurancePlan.id")}`,
    [],
  );
  const totalPrice = useMemo(() => {
    return upSells.reduce(
      (acc, { cost }) => acc + cost,
      get(generalCost, "cost"),
    );
  }, []);

  const clientEmail = get(
    find(get(project, "contact.telecoms"), {
      system: CONTACT_POINT_SYSTEM.EMAIL,
    }),
    "value",
  );
  return (
    <>
      <Modal
        width={800}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        closable
      >
        <EmailPreview
          onSend={onSubmit}
          loading={loading}
          onCancel={() => setOpen(false)}
          clientEmail={clientEmail}
          project={project}
          generalCost={generalCost}
        />
      </Modal>
      <div className="lf-quote template-product-list--container">
        <div className="template-product-list--wrapper">
          <div className="lf-quote__topbar">
            <div className="lf-quote__client">
              <strong>
                {get(project, "contact.user.firstname")}{" "}
                {get(project, "contact.user.lastname")}
              </strong>
              <span>{clientEmail}</span>
            </div>
            <div className="lf-quote__project-ref">
              {T.PROJECT_LABEL}{" "}
              <span className="text--primary">{get(project, "id")}</span>
            </div>
          </div>

          <Card
            title={T.GENERATION_CARD_TITLE}
            subtitle={T.GENERATION_CARD_SUBTITLE}
          >
            <div className="lf-quote__card-inner">
              <div className="lf-quote__status">
                <div className="lf-quote__status-icon" aria-hidden>
                  <MdDescription />
                </div>
                <h3 className="lf-quote__status-title">
                  {T.STATUS_READY_TITLE}
                </h3>
                <p className="lf-quote__status-desc">
                  {T.STATUS_READY_DESCRIPTION}
                </p>
              </div>

              <div className="lf-quote__recap">
                <h4 className="lf-quote__recap-title">{T.RECAP_TITLE}</h4>
                <div className="lf-quote__recap-row">
                  <span className="lf-quote__recap-label">
                    {T.CLIENT_LABEL}
                  </span>
                  <span className="lf-quote__recap-value">
                    {get(project, "contact.user.firstname")}{" "}
                    {get(project, "contact.user.lastname")}
                  </span>
                </div>
                <div className="lf-quote__recap-row">
                  <span className="lf-quote__recap-label">
                    {T.EMAIL_LABEL_RECAP}
                  </span>
                  <span className="lf-quote__recap-value">{clientEmail}</span>
                </div>
                <div className="lf-quote__recap-row">
                  <span className="lf-quote__recap-label">
                    {T.TELECONS_LABEL}
                  </span>
                  <span className="lf-quote__recap-value">
                    {get(generalCost, "insurancePlan.name")}
                  </span>
                </div>
                {upSells.map((upSell) => (
                  <div key={upSell.id} className="lf-quote__recap-row">
                    <span className="lf-quote__recap-label">
                      {T.CASHBACK_LABEL}
                    </span>
                    <span className="lf-quote__recap-value">
                      {get(upSell, "insurancePlan.name")}
                    </span>
                  </div>
                ))}

                <div className="lf-quote__recap-total">
                  <span className="lf-quote__recap-label">{T.TOTAL_LABEL}</span>
                  <span className="lf-quote__recap-total-value">
                    {totalPrice.toFixed(2)} €
                  </span>
                </div>
              </div>

              <div className="lf-quote__consents">
                <h4 className="lf-quote__consents-title">{T.CONSENTS_TITLE}</h4>
                <p className="lf-quote__consents-hint">{T.CONSENTS_HINT}</p>
                <div className="lf-quote__consent-row">
                  <Input
                    type="checkbox"
                    label={T.CONSENT_CALLBACK}
                    checked={get(
                      initialValues,
                      "project.fields.quoteConsentCallback",
                      false,
                    )}
                    onChange={({ target: { checked } }) => {
                      setInitialValues((prev) => ({
                        ...prev,
                        project: {
                          ...prev.project,
                          fields: {
                            ...prev.project.fields,
                            quoteConsentCallback: checked,
                          },
                        },
                      }));
                    }}
                  />
                </div>
                <div className="lf-quote__consent-row">
                  <Input
                    type="checkbox"
                    label={T.CONSENT_MARKETING}
                    checked={get(
                      initialValues,
                      "project.fields.quoteConsentMarketing",
                      false,
                    )}
                    onChange={({ target: { checked } }) => {
                      setInitialValues((prev) => ({
                        ...prev,
                        project: {
                          ...prev.project,
                          fields: {
                            ...prev.project.fields,
                            quoteConsentMarketing: checked,
                          },
                        },
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="lf-quote__cta">
                <Button
                  type="primary"
                  loading={false}
                  disabled={
                    !get(
                      initialValues,
                      "project.fields.quoteConsentCallback",
                      false,
                    ) ||
                    !get(
                      initialValues,
                      "project.fields.quoteConsentMarketing",
                      false,
                    )
                  }
                  onClick={() => setOpen(true)}
                >
                  <MdSend size={18} />
                  {T.PREVIEW_SEND}
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default View;
